import { useRef, useMemo, useState } from "react";
import { FormattingTwoNumber } from "../utils";
import level_logo from "@/assets/images/tabbar/level_logo.svg";
import personImg from "../assets/images/tabbar/person.png"
import miningImg from "../assets/images/mining/mining_icon.png"
import coinImg from "../assets/images/coin.png"
import { useNavigate } from "react-router-dom";
import SettingsDialog from "./SettingsDialog";
import TalkMessage from "./message/TalkMessageToast";
import { useDispatch, useSelector } from "react-redux";
import { changeHomePage } from "../store/module/tabbar";
import { changeMiningPoolConfig } from "../store/module/settins";
import { getMiningMiningUnread } from '@/api/mining.js'
import HomePage from "./HomePage";
// import WebApp from "@twa-dev/sdk";
import { changeLoginState } from "../store/module/h5Login";
import { useTranslation } from "react-i18next";

interface CoinProgressBarProps {
  padding?: number
  coinsShow?: boolean
  userInfo?: any
}
const CoinProgressBar = ({ padding = 0, userInfo }: CoinProgressBarProps) => {
  const { t } = useTranslation();
  // const flag = useSelector((state: any) => state.tabbar.value);
  const dispatch = useDispatch()
  const [dialog, setDialog] = useState(false)
  const [isShowMessage, setShowMessage] = useState(false)
  const navigate = useNavigate()
  const homePageType = useSelector((state: any) => state.tabbar.homePage)
  const { miningPoolConfig, settings } = useSelector((state: any) => state.settings)
  const getMiningMiningUnreadHandle = async () => {
    try {
      const { code, data } = await getMiningMiningUnread()
      if (code == '0') {
        dispatch(changeMiningPoolConfig(data))
      }
    } catch (e) {
      console.log("star page", e)
    }
  }

  return (
    <div
      style={{
        background: 'linear-gradient( 180deg, #1A514F 0%, #0B2827 100%)',
        borderRadius: '0px 0px 20px 20px'
      }}
      className={`w-full px-[16px] py-[7px] flex items-center relative justify-between`}>
      <div className="w-full flex">
        <div className="w-full h-full flex items-center justify-between">
          <div className="flex items-center flex-1 justify-between">
            <div className="w-[36px] h-[36px]  p-1 bg-[#32726E]/30 rounded-lg mr-2" onClick={() => {
              if (settings.vibration) {
                // WebApp.HapticFeedback.impactOccurred('heavy'); // 震动1000毫秒
              }
              localStorage.getItem('token') ? dispatch(changeHomePage(
                {
                  showHomePage: true,
                  id: '',
                }
              )) : dispatch(changeLoginState(true));

            }}>
              <img className="h-[28px] rounded-full w-[28px]" src={userInfo.avatar_url ? `${userInfo.avatar_url}?id=${Date.now()}` : personImg} alt="" />
            </div>
            <div onClick={() => {
              localStorage.getItem('token') ? navigate("/ranks") : dispatch(changeLoginState(true));
            }} className="level p-2 flex-1 box-border bg-[#32726E]/30 rounded-lg flex items-center justify-around">

              {/* <p className='textStroke whitespace-nowrap relative text-style-level text-[14px] leading-[18px]' data-content={`Lv ${userInfo.level ? userInfo.level : 0}`}>Lv {userInfo.level ? userInfo.level : 0}</p> */}
              <img className="w-[20px] total_1 mr-1 h-[20px]" src={coinImg} alt="" />
              {userInfo.balance ?
                <p style={{ right: 0 }} className="textStroke relative text-style-level text-[16px] leading-[19px]" data-content={userInfo.balance.toString() && FormattingTwoNumber(userInfo.balance.toString())}>{userInfo.balance.toString() && FormattingTwoNumber(userInfo.balance.toString())}</p> :
                <p style={{ right: 0 }} className="textStroke relative text-style-level text-[16px] leading-[19px]" data-content={0}>{0}</p>}
              <div className="flex items-center relative">
                <img src={level_logo} className="mr-1 w-4 h-4" alt="" />
                {!!userInfo.ponits_boost && <div style={{
                  height: '16px',
                  padding: "0px 4px",
                  background: 'linear-gradient( 135deg, #FFE600 0%, #D18C00 100%)',
                  borderRadius: '7px 7px 7px 0px'
                }}
                  className="font-semibold flex items-center text-[12px] z-[99] leading-[12px] absolute -top-[18px] -right-5 text-[#fff]">
                  +{userInfo.ponits_boost / 10}%
                </div>}
              </div>
            </div>
          </div>
          <div className="flex items-center ml-2 justify-between flex-1">
            <div onClick={async () => {
              if (settings.vibration) {
                // WebApp.HapticFeedback.impactOccurred('heavy'); // 震动1000毫秒
              }

              localStorage.getItem('token') ? navigate('/mining') : dispatch(changeLoginState(true));
              if (miningPoolConfig.is_sai_clicked) {
                return;
              }
              await getMiningMiningUnreadHandle()
            }} className="coins p-2 bg-[#32726E]/30 rounded-lg flex  justify-center items-center relative">
              <img className="w-[20px] h-[20px] mr-[4px]" src={miningImg} alt="" />
              {userInfo.sai ?
                <p style={{ right: 0 }} className="textStroke relative text-style-level text-[16px] leading-[19px]" data-content={userInfo.sai.toString() && FormattingTwoNumber(userInfo.sai.toString())}>{userInfo.sai.toString() && FormattingTwoNumber(userInfo.sai.toString())}</p> :
                <p style={{ right: 0 }} className="textStroke relative text-style-level text-[16px] leading-[19px]" data-content={0}>{0}</p>}
              {!miningPoolConfig.is_sai_clicked && <div style={{
                height: '16px',
                padding: "0px 4px",
                background: 'linear-gradient( 135deg, #FB5445 0%, #FBB11B 100%)',
                borderRadius: '7px 7px 7px 0px'
              }}
                className="font-semibold flex items-center text-[12px] z-[99] leading-[12px] absolute -top-[10px] -right-0 text-[#fff]">
                {t("other.new")}
              </div>}
            </div>
            <div className="setting ml-1 p-1 w-[36px] h-[36px] flex flex-shrink-0 justify-center items-center bg-[#32726E]/30 rounded-lg">
              <svg onClick={() => {
                if (settings.vibration) {
                  // WebApp.HapticFeedback.impactOccurred('heavy'); // 震动1000毫秒
                };
                localStorage.getItem('token') ? setDialog(true) : dispatch(changeLoginState(true));
              }} width="16px" height="16px" className="w-[30px] h-[30px]" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <defs>
                  <linearGradient x1="-2.72351586e-14%" y1="-1.94289029e-13%" x2="100%" y2="100%" id="linearGradient-1">
                    <stop stopColor={`${dialog ? '#00E49F' : '#fff'}`} offset="0%"></stop>
                    <stop stopColor={`${dialog ? '#54ADFF' : '#fff'}`} offset="100%"></stop>
                  </linearGradient>
                </defs>
                <g id="页面-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <g id="02-talk平铺" transform="translate(-24.000000, -62.000000)" fill="url(#linearGradient-1)" fillRule="nonzero">
                    <g id="编组" transform="translate(24.000000, 62.000000)">
                      <path d="M20.3763928,7.03128144 C20.8140401,7.84680779 21.6664405,8.35755721 22.5958343,8.36114773 C22.9717133,8.36465817 23.3307934,8.51655263 23.5940725,8.78341246 C23.8573515,9.05027228 24.0032606,9.41023509 23.9996978,9.78410465 L23.9996978,14.225858 C24.015306,14.9845067 23.4243561,15.6193211 22.6626849,15.6621136 C21.7332911,15.6657041 20.8808908,16.1764536 20.4432434,16.9919799 C19.9655747,17.814904 19.9655747,18.8287883 20.4432434,19.6517125 C20.8330509,20.3328113 20.6080018,21.1987424 19.9351785,21.6066159 L16.1113215,23.7875966 C15.7856445,23.9734733 15.3986785,24.0218357 15.0368932,23.9218769 C14.6751079,23.8219182 14.3686586,23.58197 14.1860229,23.2556501 C13.7414814,22.453897 12.8937841,21.9560109 11.9732665,21.9560109 C11.052749,21.9560109 10.2050516,22.453897 9.76051012,23.2556501 C9.59240968,23.5966178 9.28577562,23.8498383 8.91790653,23.9514779 C8.55003744,24.0531176 8.15603108,23.9934791 7.83521149,23.7875966 L4.06483503,21.5534213 C3.74049185,21.3623841 3.50505702,21.051742 3.40969869,20.6890082 C3.31699944,20.3201635 3.36961676,19.9300219 3.55677012,19.5985178 C4.03443883,18.7755937 4.03443883,17.7617094 3.55677012,16.9387852 C3.12134879,16.1211601 2.26754719,15.6095711 1.33732863,15.608919 C0.573565897,15.5592793 -0.0156194457,14.9205 0.000315715563,14.1593647 L0.000315715563,9.78410465 C-0.0152924283,9.02545597 0.575657405,8.39064161 1.33732863,8.34784906 C2.26672245,8.34425855 3.11912276,7.83350914 3.55677012,7.01798279 C4.03443884,6.19505867 4.03443884,5.18117433 3.55677012,4.35825021 C3.17435045,3.67619011 3.39800566,2.81562225 4.06483503,2.40334679 L7.83521149,0.23566474 C8.14718258,0.0213262048 8.5359768,-0.0511830513 8.90482183,0.0361847953 C9.26678285,0.130801273 9.57230495,0.371983034 9.74713998,0.701117952 C10.173958,1.53209944 11.0284907,2.05948733 11.9665815,2.07088022 C12.8959753,2.06728969 13.7483756,1.55654028 14.1860229,0.741013927 C14.360858,0.411879018 14.6663801,0.170697266 15.0283411,0.0760807936 C15.3919213,-0.0348003192 15.7857699,0.0135630534 16.1113215,0.209067416 L19.8683279,2.44324278 C20.5411511,2.85111627 20.7662002,3.71704739 20.3763928,4.39814621 C19.8987241,5.22107033 19.8987241,6.23495465 20.3763928,7.05787877 L20.3763928,7.03128144 Z M11.9665815,18.6543128 C15.6586407,18.6543128 18.6516461,15.6773057 18.6516461,12.0049813 C18.6516461,8.332657 15.6586407,5.35564994 11.9665814,5.35564994 C8.27452217,5.35564994 5.28151678,8.33265701 5.28151678,12.0049813 C5.28151678,13.7684937 5.98583407,15.4597771 7.23952689,16.7067687 C8.49321971,17.9537602 10.1935921,18.6543128 11.9665815,18.6543128 L11.9665815,18.6543128 Z M11.9665815,15.608919 C10.4746276,15.608762 9.13067884,14.7118647 8.5648586,13.3387461 C7.99903835,11.9656276 8.32353549,10.3885449 9.38620639,9.34692863 C10.4488773,8.30531236 12.0390192,8.00569058 13.4110788,8.58854384 C14.7831383,9.17139711 15.6650682,10.5211593 15.643367,12.0049813 C15.643367,14.0247597 13.9972141,15.6621136 11.9665815,15.6621136 L11.9665815,15.608919 Z" id="形状"></path>
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>


        </div >
      </div >
      <SettingsDialog dialog={dialog} setDialog={setDialog}></SettingsDialog>
      {isShowMessage && <TalkMessage width={180} bottom={0} text={t("other.com_soon")}></TalkMessage>}
      {/* <div style={{ background: `url(${level_bg})`, backgroundSize: '100% 100%' }} onClick={() => {
      navigate("/ranks")
    }} className="py-2 px-[5px] relative z-10 flex items-center">
    </div> */}
    </div >)
}
export default CoinProgressBar;

